import { useState } from "react";
import { Sun, Moon } from "lucide-react";

export const applyTheme = (t) => document.documentElement.classList.toggle("light", t === "light");

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => localStorage.getItem("mk-theme") || "dark");
  const flip = () => {
    const t = theme === "dark" ? "light" : "dark";
    localStorage.setItem("mk-theme", t); applyTheme(t); setTheme(t);
  };
  return (
    <button onClick={flip} data-testid="theme-toggle"
      className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      {theme === "dark" ? "Light mode" : "Dark mode"}
    </button>
  );
}
